"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { openDB } from "idb";
const DB_NAME = "ChartDataDB";
const DB_VERSION = 1;
const STORE_NAME = "chartData";
class IndexedDBService {
  constructor() {
    this.dbPromise = this.initDB();
  }
  initDB() {
    return __async(this, null, function* () {
      return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(STORE_NAME)) {
            const store = db.createObjectStore(STORE_NAME, { keyPath: "id" });
            store.createIndex("reportingObjectModelRecords  ", "entityId", { unique: false });
          }
        }
      });
    });
  }
  saveChartData(entityId, year, month, recordType, data) {
    return __async(this, null, function* () {
      const db = yield this.dbPromise;
      const id = `${entityId}_${year}_${month}_${recordType}`;
      yield db.put(STORE_NAME, {
        id,
        entityId,
        year,
        month,
        recordType,
        data,
        timestamp: Date.now()
      });
    });
  }
  getChartData(entityId, year, month, recordType) {
    return __async(this, null, function* () {
      const db = yield this.dbPromise;
      const id = `${entityId}_${year}_${month}_${recordType}`;
      return db.get(STORE_NAME, id);
    });
  }
  /**
   * Get all data from IndexedDB for multiple entities and months, and aggregate it
   * @param entityIds Array of entity IDs to get data for
   * @param recordType The type of record to get data for
   * @returns Aggregated data from all entities and months
   */
  getAggregatedData(entityIds, recordType) {
    return __async(this, null, function* () {
      const allData = {};
      for (const entityId of entityIds) {
        const currentDate = /* @__PURE__ */ new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        for (let i = 0; i < 12; i++) {
          let month = currentMonth - i;
          let year = currentYear;
          if (month <= 0) {
            month += 12;
            year -= 1;
          }
          const data = yield this.getChartData(entityId, year, month, recordType);
          if (data) allData[data.id] = data;
        }
      }
      return allData;
    });
  }
}
export const indexedDBService = new IndexedDBService();
